import Swiper from "swiper";
import { A11y, EffectFade, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-featuredmedia").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, EffectFade, Navigation],
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 500,
    allowTouchMove: false,
    simulateTouch: false,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
  });
});
